// extracted by mini-css-extract-plugin
export default {"container":"ReCaptcha__container--2Yq"};